module.exports = __webpack_public_path__ + "img/hz2.5445c100.png";